module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/Luminary-homepage-L-1024x576.e35fbb3.png";